<template>
  <div id="charger-status-monitor">
    <a-form class="ant-advanced-search-form" :form="form" @submit="getInfos">
      <a-row :gutter="24">
        <a-col :span="8" v-if="!this.SingleCompanyUser">
          <a-form-item label="Company">
            <a-select
              @change="onCompanyChange"
              v-decorator="[
                'company',
                {
                  rules: [{ required: true, message: 'Please select a company!' }]
                }
              ]"
              :allowClear="true"
              placeholder="Select company"
            >
              <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="Location">
            <a-select
              @change="onDepotChange"
              v-decorator="[
                'depot',
                {
                  initialValue: displayDepots.length == 1 ? displayDepots[0] : undefined
                }
              ]"
              :allowClear="true"
              placeholder="Select location"
              :disabled="depotDisabled"
            >
              <a-select-opt-group label="Depots" key="depotGroup">
                <a-select-option v-for="(item, index) in displayDepots" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select-opt-group>
              <a-select-opt-group label="Transformers" key="transformerGroup" v-if="hasTransformer">
                <a-select-option v-for="(item, index) in displayTransformers" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6" :style="{ textAlign: 'right' }" :offset="getOffsetValue">
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              :style="{ marginLeft: '8px' }"
              icon="monitor"
              :disabled="monitoringDisabled"
            >
              Start Monitoring
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <br />
    <div
      style="padding: 20px; border: 1px solid #d9d9d9; overflow-x: auto; min-width: 1200px; border-radius: 6px; box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);"
    >
      <a-spin :spinning="loading">
        <h3 style="text-align:center">Summary</h3>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover slot="title" title="Charger Information" placement="topLeft">
                <a-tag color="#108ee9">Available</a-tag>
                <div slot="content">
                  <p>Click <b>Filter</b> to view chargers in the table</p>
                </div>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Available')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.availableCount }}</p>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover slot="title" title="Charger Information" placement="topLeft">
                <a-tag color="#87d068">Charging</a-tag>
                <div slot="content">
                  <p>Click <b>Filter</b> to view chargers in the table</p>
                </div>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Charging')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.chargingCount }}</p>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover slot="title" title="Charger Information" placement="topLeft">
                <a-tag color="#F1C40F">Completed</a-tag>
                <div slot="content">
                  <p>Click <b>Filter</b> to view chargers in the table</p>
                </div>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Completed')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.completedCount }}</p>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover slot="title" title="Charger Information" placement="topLeft">
                <div v-if="disconnectedChargersList.length" slot="content" style="overflow-y: auto; max-height: 200px;">
                  <p v-for="(item, index) in orderedDisconnectedChargersList" :key="index">
                    <b>Location: </b>{{ item.location }} <b>Charger Number: </b>{{ item.chargerNumber }}
                  </p>
                </div>
                <div v-else slot="content">
                  <p>No Chargers Disconnected</p>
                </div>
                <a-tag color="#566573">Disconnected</a-tag>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Disconnected')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.disconnectedCount }}</p>
            </a-card>
          </a-col>
        </a-row>
        <br />
        <a-row :gutter="24">
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover title="Charger Information" placement="topLeft" slot="title">
                <div v-if="errorChargersList.length" slot="content" style="overflow-y: auto; max-height: 200px;">
                  <p v-for="(item, index) in orderedErrorChargersList" :key="index">
                    <b>Location: </b>{{ item.location }} <b>Charger Number: </b>{{ item.chargerNumber }}
                  </p>
                </div>
                <div v-else slot="content">
                  <p>No Chargers in Error</p>
                </div>
                <a-tag color="#f50">Error</a-tag>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Error')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.errorCount }}</p>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover title="Charger Information" placement="topLeft" slot="title">
                <div v-if="noDataChargersList.length" slot="content" style="overflow-y: auto; max-height: 200px;">
                  <p v-for="(item, index) in orderedNoDataChargersList" :key="index">
                    <b>Location: </b>{{ item.location }} <b>Charger Number: </b>{{ item.chargerNumber }}
                  </p>
                </div>
                <div v-else slot="content">
                  <p>No Chargers in No_Data</p>
                </div>
                <a-tag color="#f50">No_Data</a-tag>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('No_Data')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.noDataCount }}</p>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover title="Charger Information" placement="topLeft" slot="title">
                <div v-if="pausedChargersList.length" slot="content" style="overflow-y: auto; max-height: 200px;">
                  <p v-for="(item, index) in orderedPausedChargersList" :key="index">
                    <b>Location: </b>{{ item.location }} <b>Charger Number: </b>{{ item.chargerNumber }}
                  </p>
                </div>
                <div v-else slot="content">
                  <p>No Chargers Paused</p>
                </div>
                <a-tag color="#F39C12">Pause</a-tag>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Pause')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.pausedCount }}</p>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :headStyle="{ backgroundColor: '#fbfbfb' }">
              <a-popover slot="title" title="Charger Information" placement="topLeft">
                <a-tag color="#F39C12">Other</a-tag>
                <div slot="content">
                  <p>Click <b>Filter</b> to view chargers in the table</p>
                </div>
              </a-popover>
              <div slot="extra">
                <a-button v-on:click="filterChargerStatus('Other')" size="small">Filter</a-button>&nbsp;
                <a-button v-on:click="resetChargerStatusFilter()" size="small">Reset</a-button>
              </div>
              <p><b>Number of Chargers: </b>{{ this.otherCount }}</p>
            </a-card>
          </a-col>
        </a-row>
        <br />
        <h4 style="text-align:center">
          {{ this.data.length + " Total Chargers Found" }}
        </h4>
      </a-spin>
    </div>
    <br />
    <div class="search-result-list">
      <a-table
        :columns="columns"
        :dataSource="handleData"
        :scroll="{ x: 1500, y: 1000 }"
        :loading="loading"
        :rowKey="(record, index) => index + 1"
        :pagination="{
          defaultPageSize: 20,
          showSizeChanger: true,
          position: 'both',
          showTotal: updateNumberofRows
        }"
        :footer="() => this.numberOfRows + ' Chargers Found'"
        @change="onTableChange"
        size="small"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dataPolling: null,
      formItemLayout: "",
      regionSelected: "",
      loading: false,
      monitoringDisabled: true,
      depotDisabled: true,
      hasTransformer: false,
      pageOffset: 0,
      currentChargerList: [],
      currentBusList: [],
      transformerList: [],
      // charger lists and counters for the Summary tab.
      disconnectedChargersList: [],
      errorChargersList: [],
      noDataChargersList: [],
      pausedChargersList: [],
      availableCount: 0,
      chargingCount: 0,
      completedCount: 0,
      errorCount: 0,
      disconnectedCount: 0,
      noDataCount: 0,
      pausedCount: 0,
      otherCount: 0,
      form: this.$form.createForm(this),
      data: [],
      numberOfRows: 0,
      filteredInfo: null
    };
  },

  computed: {
    ...mapState(["CognitoUser", "CompanyMap", "SingleCompanyUser"]),

    columns() {
      let { filteredInfo } = this;
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: "Index",
          key: "index",
          customRender: (text, record, index) => this.pageOffset + index + 1,
          width: 80,
          align: "center"
        },
        {
          title: () => {
            return (
              <span>
                Location&nbsp;
                <a-tooltip title="Locations displayed in orange mean there is a mismatch between charger location from live data and the provided charger list.">
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "depot",
          width: 200,
          align: "center",
          customRender: (text, row) => {
            // if there is a location mismatch, display the text in orange.
            if (row.locationMismatch) {
              // return <b style="color:#F39C12"> {text} </b>;
              return (
                <a-popover title="Charger Information" placement="top">
                  <template slot="content">
                    <p>
                      <b>Location from Charger List: </b>
                      {row.chargerListLocation}
                    </p>
                  </template>
                  <div style="cursor:pointer">
                    <b style="color:#F39C12"> {text} </b>
                  </div>
                </a-popover>
              );
            } else {
              return text;
            }
          }
        },
        {
          title: "Charger #",
          dataIndex: "chargerNumber",
          sorter: (chargerOne, chargerTwo) => {
            let numberOne, numberTwo;
            if (chargerOne.chargerNumber == "N/A") {
              numberOne = Number.MAX_SAFE_INTEGER;
            } else {
              numberOne = chargerOne.chargerNumber;
            }

            if (chargerTwo.chargerNumber == "N/A") {
              numberTwo = Number.MAX_SAFE_INTEGER;
            } else {
              numberTwo = chargerTwo.chargerNumber;
            }
            return numberOne - numberTwo;
          },
          width: 120,
          align: "center"
        },
        {
          title: "Status",
          dataIndex: "chargerStatus",
          customRender: (text, row) => {
            // parse the provided error code, and prepare the description string for the same.
            var descriptionSring = "";
            var tagColor, messageString;
            if (this.regionSelected == "sa-east-1") {
              if (row.errorCodeOne == "No_Data") {
                descriptionSring = "No Error Code Available";
              } else if (row.errorCodeOne == "0x00000000") {
                descriptionSring = "No Error";
              } // only parse the error code if it is [NOT] No_Data or No Error.
              else {
                let errorDescriptionArray = this.getErrorDescription(row.errorCodeOne.slice(2, 10), 1);
                for (let counter = 0; counter < errorDescriptionArray.length; counter++) {
                  descriptionSring += errorDescriptionArray[counter];
                  if (!(counter == errorDescriptionArray.length - 1)) {
                    descriptionSring += ", ";
                  }
                }
              }

              // only proceed to parse the second error code is NOT No_Data.
              if (row.errorCodeTwo != "No_Data") {
                let secondErrorDescriptionArray = this.getErrorDescription(row.errorCodeTwo.slice(2, 10), 2);
                for (let counterTwo = 0; counterTwo < secondErrorDescriptionArray.length; counterTwo++) {
                  if (counterTwo == 0) {
                    // if no error was found from the error code #1, empty the description string.
                    if (descriptionSring == "No Error") {
                      descriptionSring = "";
                    } else {
                      // else, add on to error code #1's description string.
                      descriptionSring += " || ";
                    }
                  }
                  descriptionSring += secondErrorDescriptionArray[counterTwo];
                  if (!(counterTwo == secondErrorDescriptionArray.length - 1)) {
                    descriptionSring += ", ";
                  }
                }
              }
            } else {
              if (row.errorCode == "No_Data") {
                descriptionSring = "No Error Code Available";
              } else if (row.errorCode == "0x00000000") {
                descriptionSring = "No Error";
              } // only parse the error code if it is [NOT] No_Data or No Error.
              else {
                let errorDescriptionArray = this.getErrorDescription(row.errorCode.slice(2, 10), 1);
                for (let counter = 0; counter < errorDescriptionArray.length; counter++) {
                  descriptionSring += errorDescriptionArray[counter];
                  if (!(counter == errorDescriptionArray.length - 1)) {
                    descriptionSring += ", ";
                  }
                }
              }
            }

            // set the message and tag color according to the chargerStatus.
            if (text == "Error") {
              tagColor = "#f50";
              messageString = "Charger in Error";
            } else if (text == "No_Data") {
              tagColor = "#f50";
              messageString = "No RS485 Data from Charger";
            } else if (text == "Ready") {
              tagColor = "#0FD2F1";
              messageString = "Ready to Charge";
            } else if (text == "Charging") {
              tagColor = "#87d068";
              messageString = "Currently Charging";
            } else if (text == "Completed") {
              tagColor = "#F1C40F";
              messageString = "Charger Finished Charging";
            } else if (text == "Available") {
              tagColor = "#108ee9";
              messageString = "Charger Available for Charging";
            } else if (text == "Disconnected") {
              tagColor = "#566573";
              messageString = "No Internet or Module is Disconnected";
            } else {
              tagColor = "#F39C12";
              messageString = "Charger is in " + text;
            }
            const content_US = (
              <div>
                <p>
                  <b>Error Code: </b>
                  {row.errorCode}
                </p>
                <p>
                  <b>Description: </b>
                  {descriptionSring}
                </p>
                <p>
                  <b>Message: </b>
                  {messageString}
                </p>
              </div>
            );
            const content_SA = (
              <div>
                <p>
                  <b>Error Code #1: </b>
                  {row.errorCodeOne}
                </p>
                <p>
                  <b>Error Code #2: </b>
                  {row.errorCodeTwo}
                </p>
                <p>
                  <b>Gun #1 Reset Count: </b>
                  {row.gunOneResetCount}
                </p>
                <p>
                  <b>Gun #2 Reset Count: </b>
                  {row.gunTwoResetCount}
                </p>
                <p>
                  <b>Description: </b>
                  {descriptionSring}
                </p>
                <p>
                  <b>Message: </b>
                  {messageString}
                </p>
              </div>
            );
            // finally, return the hoverable status tag depending on the region selected.
            if (this.regionSelected == "sa-east-1") {
              return (
                <a-popover title="Charger Information" placement="topLeft" content={content_SA}>
                  <a-tag color={tagColor}>{text}</a-tag>
                </a-popover>
              );
            } else {
              return (
                <a-popover title="Charger Information" placement="topLeft" content={content_US}>
                  <a-tag color={tagColor}>{text}</a-tag>
                </a-popover>
              );
            }
          },
          sorter: (chargerOne, chargerTwo) => chargerOne.chargerStatus.localeCompare(chargerTwo.chargerStatus),
          filters: [
            {
              text: "Available",
              value: "Available"
            },
            {
              text: "Charging",
              value: "Charging"
            },
            {
              text: "Completed",
              value: "Completed"
            },
            {
              text: "Disconnected",
              value: "Disconnected"
            },
            {
              text: "Error",
              value: "Error"
            },
            {
              text: "No_Data",
              value: "No_Data"
            },
            {
              text: "Pause",
              value: "Pause"
            },
            {
              text: "Other",
              value: "Other"
            }
          ],
          filterMultiple: true,
          onFilter: (value, record) => {
            if (value == "Other") {
              return (
                record.chargerStatus === "Ready" ||
                record.chargerStatus === "Gun_Connected" ||
                record.chargerStatus === "Self_Test" ||
                record.chargerStatus === "Waiting"
              );
            } else {
              return record.chargerStatus === value;
            }
          },
          filteredValue: filteredInfo.chargerStatus || null,
          width: 150,
          align: "center"
        },
        {
          title: "Override",
          dataIndex: "chargerOverridden",
          customRender: text => {
            if (text == "ON") {
              return <b style="color:#f50"> {text} </b>;
            } else {
              return text;
            }
          },
          filters: [
            {
              text: "On",
              value: "ON"
            },
            {
              text: "Off",
              value: "OFF"
            }
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.chargerOverridden === value,
          width: 110,
          align: "center"
        },
        {
          title: "SOC",
          dataIndex: "soc",
          align: "center",
          customRender: (text, row) => {
            if (text != "No_Data") {
              var color, barStatus;
              var percentage = Number(text);
              // check the percentage charged in order to determine the color of the bar.
              if (percentage <= 15) {
                color = "#f50";
              } else if (percentage <= 50) {
                color = "#F1C40F";
              } else {
                color = "#108ee9";
              }
              // check the chargerStatus in order to determine the status of the bar.
              if (row.chargerStatus == "Completed") {
                color = "#87d068";
                barStatus = "normal";
              } else if (row.chargerStatus == "Charging") {
                barStatus = "active";
              } else {
                barStatus = "normal";
              }
              return (
                <div style="width: 120px">
                  <a-progress percent={percentage} strokeColor={color} size="small" status={barStatus} />
                </div>
              );
            } else {
              return (
                <div style="width: 120px">
                  <a-progress size="small" status="exception" />
                </div>
              );
            }
          },
          sorter: (chargerOne, chargerTwo) => {
            var socOne;
            var socTwo;
            if (chargerOne.soc == "No_Data") {
              socOne = -1;
            } else {
              socOne = Number(chargerOne.soc);
            }
            if (chargerTwo.soc == "No_Data") {
              socTwo = -1;
            } else {
              socTwo = Number(chargerTwo.soc);
            }
            return socOne - socTwo;
          },
          width: 155
        },
        {
          title: "Charging Time Left (min)",
          dataIndex: "remainingTime",
          align: "center",
          sorter: (chargerOne, chargerTwo) => {
            var timeOne;
            var timeTwo;
            if (chargerOne.remainingTime == "No_Data") {
              timeOne = -1;
            } else {
              timeOne = Number(chargerOne.remainingTime);
            }
            if (chargerTwo.remainingTime == "No_Data") {
              timeTwo = -1;
            } else {
              timeTwo = Number(chargerTwo.remainingTime);
            }
            return timeOne - timeTwo;
          },
          width: 120
        },
        {
          title: "Bus #",
          dataIndex: "busNumber",
          customRender: (text, row) => {
            return (
              <a-popover title="Charger Information" placement="top">
                <template slot="content">
                  <p>
                    <b>VIN: </b>
                    {row.vin}
                  </p>
                </template>
                <div style="cursor:pointer">
                  <u>{text}</u>
                </div>
              </a-popover>
            );
          },
          width: 100,
          align: "center"
        },
        {
          title: "AC Current",
          dataIndex: "acCurrent",
          width: 100,
          align: "center"
        },
        {
          title: "Energy",
          dataIndex: "chargedEnergy",
          width: 100,
          align: "center"
        },
        {
          title: "Odometer",
          dataIndex: "odometer",
          width: 100,
          align: "center"
        },
        {
          title: "Update Time",
          dataIndex: "timestampUtc",
          align: "center"
        }
      ];
      return columns;
    },

    handleData() {
      const jsonData = this.data;
      // first, iterate through the data and retrieve the charger number, priority, and bus number for each charger
      // from the local storage.
      jsonData.forEach(item => {
        // look for the chargerNumber and priority.
        let chargerNumberFound = false;
        this.currentChargerList.forEach(charger => {
          if (item.mac == charger.macID) {
            item.priority = charger.priority;
            item.chargerNumber = charger.chargerNumber;
            // also check to see if the location from live data and charger list are same or not.
            if (item.depot != charger.depot) {
              item.locationMismatch = true;
              item.chargerListLocation = charger.depot;
            } else {
              item.locationMismatch = false;
              item.chargerListLocation = "N/A";
            }
            chargerNumberFound = true;
          }
        });
        if (!chargerNumberFound) {
          item.priority = "N/A";
          item.chargerNumber = "N/A";
          item.locationMismatch = false;
          item.chargerListLocation = "N/A";
        }

        // look for the busNumber.
        if (item.vin == "No_Data" || item.vin == "Invalid") {
          item.busNumber = "N/A";
        } else {
          let busNumberFound = false;
          this.currentBusList.forEach(bus => {
            if (item.vin == bus.vin) {
              item.busNumber = bus.busNumber;
              busNumberFound = true;
            }
          });
          if (!busNumberFound) {
            item.busNumber = "N/A";
          }
        }

        // format the timestampUtc, and check for disconnected chargers.
        if (item.timestampUtc) {
          const updateTime = this.$moment(item.timestampUtc);
          const currentTime = this.$moment(new Date());
          const diff = currentTime.diff(updateTime, "minutes");
          // if the last update time is more than 10 minutes ago, change the charger soc and status to disconnected.
          if (diff > 10) {
            item.soc = "No_Data";
            item.chargerStatus = "Disconnected";
          }
          item.timestampUtc = this.$moment(item.timestampUtc)
            .local()
            .format("YYYY-MM-DD HH:mm");
        }
        if (item.chargerOverridden == "true") {
          item.chargerOverridden = "ON";
        } else {
          item.chargerOverridden = "OFF";
        }
      });
      // next, sort the data by default using the depot and chargerNumber, and return the final data.
      jsonData.sort((chargerOne, chargerTwo) => {
        if (chargerOne.depot.localeCompare(chargerTwo.depot) == 0) {
          let numberOne, numberTwo;
          if (chargerOne.chargerNumber == "N/A") {
            numberOne = Number.MAX_SAFE_INTEGER;
          } else {
            numberOne = chargerOne.chargerNumber;
          }

          if (chargerTwo.chargerNumber == "N/A") {
            numberTwo = Number.MAX_SAFE_INTEGER;
          } else {
            numberTwo = chargerTwo.chargerNumber;
          }
          return numberOne - numberTwo;
        } else {
          return chargerOne.depot.localeCompare(chargerTwo.depot);
        }
      });
      // update the Summary tab using the new data.
      this.updateSummaryTab(jsonData);
      return jsonData;
    },

    // return a list of companies from the CompanyMap.
    displayCompanies() {
      let companyList = [];
      this.CompanyMap.forEach(function(value, key) {
        companyList.push(key);
      });
      return companyList.sort();
    },

    displayDepots() {
      if (this.hasTransformer) {
        let depotList = [];
        this.transformerList.forEach(transformer => {
          var position = transformer.indexOf("_T");
          var depot = transformer.slice(0, position);
          if (!depotList.includes(depot)) {
            depotList.push(depot);
          }
        });
        return depotList;
      } else {
        return this.transformerList;
      }
    },

    displayTransformers() {
      return this.transformerList;
    },

    // computed properties to return the sorted charger lists for the Summary tab.
    orderedNoDataChargersList() {
      return this.noDataChargersList.slice().sort((itemOne, itemTwo) => {
        return itemOne.chargerNumber - itemTwo.chargerNumber;
      });
    },

    orderedErrorChargersList() {
      return this.errorChargersList.slice().sort((itemOne, itemTwo) => {
        return itemOne.chargerNumber - itemTwo.chargerNumber;
      });
    },

    orderedPausedChargersList() {
      return this.pausedChargersList.slice().sort((itemOne, itemTwo) => {
        return itemOne.chargerNumber - itemTwo.chargerNumber;
      });
    },

    orderedDisconnectedChargersList() {
      return this.disconnectedChargersList.slice().sort((itemOne, itemTwo) => {
        return itemOne.chargerNumber - itemTwo.chargerNumber;
      });
    },

    getOffsetValue() {
      if (this.SingleCompanyUser) {
        return 8;
      }
      return 0;
    }
  },

  methods: {
    updateNumberofRows(total) {
      this.numberOfRows = total;
    },

    resetChargerStatusFilter() {
      this.filteredInfo = {
        chargerStatus: []
      };
    },

    filterChargerStatus(chargerStatus) {
      this.filteredInfo = {
        chargerStatus: [chargerStatus]
      };
    },

    startDataLoop() {
      this.dataPolling = setInterval(() => {
        this.updateChargerData();
      }, 10000);
    },

    getInfos(e) {
      e.preventDefault();
      this.form.validateFields(async (error, fieldValues) => {
        // return if form validation fails (company is not selected).
        if (error) {
          return;
        }
        this.data = [];
        this.currentChargerList = [];
        this.currentBusList = [];
        this.loading = true;
        this.pageOffset = 0;
        try {
          // firstly, make an API call to retrieve the depot information from the company name.
          const promiseArray = [];
          if (fieldValues.depot) {
            if (!this.hasTransformer) {
              let queryParams = {
                objectType: "DPO#",
                entityId: "DPO#" + fieldValues.depot,
                company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldValues.company
              };
              promiseArray.push(this.getDepotData(queryParams));
            } else {
              let selectedDepotList = this.transformerList.filter(depot => depot.includes(fieldValues.depot));
              selectedDepotList.forEach(depotName => {
                let queryParams = {
                  objectType: "DPO#",
                  entityId: "DPO#" + depotName,
                  company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldValues.company
                };
                promiseArray.push(this.getDepotData(queryParams));
              });
            }
          } else {
            this.transformerList.forEach(depotName => {
              let queryParams = {
                objectType: "DPO#",
                entityId: "DPO#" + depotName,
                company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldValues.company
              };
              promiseArray.push(this.getDepotData(queryParams));
            });
          }
          let dataArray = await Promise.all(promiseArray);
          let depotData = dataArray.flat(Infinity);
          // check if no data is returned; display a message to user in that case.
          if (!depotData.length) {
            throw new Error("No depot data available for selected company!");
          }
          // parse through the returned data, and combine the data to store the charger list.
          depotData.forEach(depot => {
            if (depot.isActive) {
              const chargerList = JSON.parse(depot.chargerList);
              chargerList.forEach(charger => {
                this.currentChargerList.push(charger);
              });
            }
          });
          // display a warning message if no active depots found for the search criteria.
          if (!this.currentChargerList.length) {
            this.$message.warning("No active depot(s) found for this search criteria!");
          }

          // now, make an API call to retrieve the fleet lists, and combine the data to store the bus list.
          const fleetPromiseArray = [];
          let paramsTwo = {
            entityId: "FLT#",
            company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldValues.company
          };
          fleetPromiseArray.push(this.getDepotData(paramsTwo));
          let fleetDataArray = await Promise.all(fleetPromiseArray);
          let fleetData = fleetDataArray.flat(Infinity);
          if (!fleetData.length) {
            throw new Error("No fleet data available for selected company!");
          }
          // combine data from the API call to store the bus list.
          fleetData.forEach(list => {
            if (list.isActive) {
              const busList = JSON.parse(list.busList);
              busList.forEach(bus => {
                this.currentBusList.push(bus);
              });
            }
          });
          // display a warning message if no active fleets found for the company.
          if (!this.currentBusList.length) {
            this.$message.warning("No active fleet(s) found for this company!");
          }
          // finally, make an API call to retrieve the gateway item data, and start the loop to update charger data every 10 seconds.
          this.updateChargerData();
        } catch (error) {
          this.$message.error(error.message);
          this.loading = false;
          return;
        }
      });
    },

    updateSummaryTab(data) {
      // reset counters and empty arrays before iterating over the data.
      let availableCount = 0,
        disconnectedCount = 0,
        chargingCount = 0,
        completedCount = 0,
        errorCount = 0,
        otherCount = 0,
        noDataCount = 0,
        pausedCount = 0;
      this.disconnectedChargersList = [];
      this.errorChargersList = [];
      this.noDataChargersList = [];
      this.pausedChargersList = [];

      data.forEach(item => {
        // increase the individual status counters for the Summary tab.
        switch (item.chargerStatus) {
          case "Available":
            availableCount += 1;
            break;
          case "Charging":
            chargingCount += 1;
            break;
          case "Completed":
            completedCount += 1;
            break;
          case "Disconnected": {
            disconnectedCount += 1;
            let disconnectedCharger = {
              location: item.depot,
              chargerNumber: item.chargerNumber
            };
            this.disconnectedChargersList.push(disconnectedCharger);
            break;
          }
          case "No_Data": {
            noDataCount += 1;
            let noDataCharger = {
              location: item.depot,
              chargerNumber: item.chargerNumber
            };
            this.noDataChargersList.push(noDataCharger);
            break;
          }
          case "Pause": {
            pausedCount += 1;
            let pausedCharger = {
              location: item.depot,
              chargerNumber: item.chargerNumber
            };
            this.pausedChargersList.push(pausedCharger);
            break;
          }
          case "Error": {
            errorCount += 1;
            let errorCharger = {
              location: item.depot,
              chargerNumber: item.chargerNumber
            };
            this.errorChargersList.push(errorCharger);
            break;
          }
          default:
            otherCount += 1;
            break;
        }
      });

      // update the charger status counters for the Summary tab.
      this.availableCount = availableCount;
      this.chargingCount = chargingCount;
      this.completedCount = completedCount;
      this.errorCount = errorCount;
      this.disconnectedCount = disconnectedCount;
      this.pausedCount = pausedCount;
      this.noDataCount = noDataCount;
      this.otherCount = otherCount;
    },

    updateChargerData() {
      this.form.validateFields(async (error, fieldsValue) => {
        try {
          const gatewayPromiseArray = [];
          let gatewayParams = {
            company: this.SingleCompanyUser ? this.displayCompanies[0] : fieldsValue.company,
            depot: fieldsValue.depot
          };
          gatewayPromiseArray.push(this.getGatewayItemData(gatewayParams));
          let gatewayDataArray = await Promise.all(gatewayPromiseArray);
          let gatewayData = gatewayDataArray.flat(Infinity);
          // check if no data is returned; display a message to user in that case.
          if (!gatewayData.length) {
            throw new Error("No gateway data available for selected options!");
          }
          // filter the returned data to remove the test depot (Santa_Ana) entries.
          this.data = gatewayData.filter(gatewayObject => {
            if (this.transformerList.includes(gatewayObject.depot)) {
              return gatewayObject;
            }
          });
          this.monitoringDisabled = true;
          // start the data loop if it is already not started.
          if (!this.dataPolling) {
            // update the current number of rows in the table.
            this.numberOfRows = this.data.length;
            this.startDataLoop();
          }
        } catch (error) {
          this.$message.error(error.message);
        }
        this.loading = false;
      });
    },

    async getDepotData(data) {
      try {
        // add region to the query parameter before making the API call.
        data.region = this.CompanyMap.get(data.company).region;
        this.regionSelected = data.region;
        let response = await this.$axios.get("https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/depotitem", {
          params: data
        });
        let items = response.data.Items;
        return Promise.resolve(items);
      } catch (error) {
        // if no response is available, means it is a network error or refreshing tokens.
        if (!error.response) {
          return Promise.reject(new Error("Refreshing access tokens!"));
        } else {
          let response = error.response;
          if (response.status == 400) {
            return Promise.reject(response.data.message);
          }
        }
      }
    },

    async getGatewayItemData(data) {
      try {
        // add region to the query parameter before making the API call.
        data.region = this.CompanyMap.get(data.company).region;
        this.regionSelected = data.region;
        let response = await this.$axios.get(
          "https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/gatewayitem",
          { params: data }
        );
        let items = response.data.Items;
        return Promise.resolve(items);
      } catch (error) {
        // if no response is available, means it is a network error or refreshing tokens.
        if (!error.response) {
          return Promise.reject(new Error("Refreshing access tokens!"));
        } else {
          let response = error.response;
          if (response.status == 400) {
            return Promise.reject(response.data.message);
          }
        }
      }
    },

    onCompanyChange(value) {
      // stop the updateChargerDataLoop, and set it to null.
      clearInterval(this.dataPolling);
      this.dataPolling = null;
      this.form.resetFields(["depot"]);
      if (!value) {
        this.monitoringDisabled = true;
        this.depotDisabled = true;
      } else {
        this.monitoringDisabled = false;
        this.depotDisabled = false;
        this.transformerList = this.CompanyMap.get(value).depots.sort();
        this.hasTransformer = this.CompanyMap.get(value).hasTransformer;
      }
    },

    onDepotChange() {
      // stop the updateChargerDataLoop, and set it to null.
      clearInterval(this.dataPolling);
      this.dataPolling = null;
      this.monitoringDisabled = false;
    },

    onTableChange(pagination, filters, sorter, { currentDataSource }) {
      // update the current number of rows in the table, and the page offset.
      this.pageOffset = (pagination.current - 1) * pagination.pageSize;
      this.numberOfRows = currentDataSource.length;
      this.filteredInfo = filters;
    },

    // function to take in the error code, and return the array of error descriptions.
    getErrorDescription(errorCode, tableNumber) {
      var hexToBinary = require("hex-to-binary");
      var errorDescriptionArray = [];
      var binaryCode = hexToBinary(errorCode);
      binaryCode = this.reverseString(binaryCode);
      for (var counter = 0; counter < binaryCode.length; counter++) {
        // if the bit is on, get the error description for that bit, and add it to errorDescriptionArray.
        if (binaryCode[counter] == "1") {
          if (this.regionSelected == "us-west-2") {
            errorDescriptionArray.push(this.errorTable_US(counter));
          } else if (this.regionSelected == "sa-east-1") {
            if (tableNumber == 1) {
              errorDescriptionArray.push(this.errorTable_SA(counter));
            } else {
              errorDescriptionArray.push(this.secondErrorTable_SA(counter));
            }
          }
        }
      }
      return errorDescriptionArray;
    },

    // function to simply reverse a string.
    reverseString(str) {
      if (str === "") return "";
      else return this.reverseString(str.substr(1)) + str.charAt(0);
    },

    // error code translation table for US.
    errorTable_US(errorBit) {
      var errStr;
      switch (errorBit) {
        case 0:
          errStr = "SPD Warning";
          break;
        case 1:
          errStr = "Charging Station Overheating";
          break;
        case 2:
          errStr = "Temp. Sensor of Gun 02 Shorted";
          break;
        case 3:
          errStr = "Please Re-plug Charging Guns (Charging Station Not Responding)";
          break;
        case 4:
          errStr = "PWM Not Responding";
          break;
        case 5:
          errStr = "Charging Prohibited by the Vehicle";
          break;
        case 6:
          errStr = "Contactor Not Pulling In";
          break;
        case 7:
          errStr = "HMI Disconnected";
          break;
        case 8:
          errStr = "Gun 01 Overheating";
          break;
        case 9:
          errStr = "Gun 02 Overheating";
          break;
        case 10:
          errStr = "Reserved";
          break;
        case 11:
          errStr = "Reserved";
          break;
        case 12:
          errStr = "Power Outage";
          break;
        case 13:
          errStr = "Reserved";
          break;
        case 14:
          errStr = "Reserved";
          break;
        case 15:
          errStr = "RS485 Communication Not Responding";
          break;
        case 16:
          errStr = "Reserved";
          break;
        case 17:
          errStr = "Reserved";
          break;
        case 18:
          errStr = "Reserved";
          break;
        case 19:
          errStr = "Smart Card Invalid";
          break;
        case 20:
          errStr = "Reserved";
          break;
        case 21:
          errStr = "RS485 Communication Error";
          break;
        case 22:
          errStr = "Reserved";
          break;
        case 23:
          errStr = "Overcurrent Protection";
          break;
        case 24:
          errStr = "Reserved";
          break;
        case 25:
          errStr = "Please Re-plug Charging Guns (Vehicle Not Responding)";
          break;
        case 26:
          errStr = "Return Signal of the Contactor Failed";
          break;
        case 27:
          errStr = "Temp. Sensor of Charging Station Disconnected";
          break;
        case 28:
          errStr = "Temp. Sensor of Charging Station Shorted";
          break;
        case 29:
          errStr = "Temp. Sensor of Gun 01 Disconnected";
          break;
        case 30:
          errStr = "Temp. Sensor of Gun 01 Shorted";
          break;
        case 31:
          errStr = "Temp. Sensor of Gun 02 Disconnected";
          break;
        default:
          errStr = "Unknown Error Code";
      }
      return errStr;
    },

    // error code translation table for SA.
    errorTable_SA(errorBit) {
      var errStr;
      switch (errorBit) {
        case 0:
          errStr = "Lighting Arrester Warning";
          break;
        case 1:
          errStr = "Internal Over-temperature Protection";
          break;
        case 2:
          errStr = "Charging Gun2 Temperature Sensor Short-circuit";
          break;
        case 3:
          errStr = "Timeout- Charging Gun Needs To Plug In Again";
          break;
        case 4:
          errStr = "PWM Not Responding";
          break;
        case 5:
          errStr = "Charging Prohibited by the Vehicle";
          break;
        case 6:
          errStr = "Main Contactor Pull-out";
          break;
        case 7:
          errStr = "HMI Disconnected";
          break;
        case 8:
          errStr = "Charging Gun 01 Overheating";
          break;
        case 9:
          errStr = "Charging Gun 02 Overheating";
          break;
        case 10:
          errStr = "Reserved";
          break;
        case 11:
          errStr = "Contactor 1 failure (Reserved)";
          break;
        case 12:
          errStr = "Contactor 2 failure (Reserved)";
          break;
        case 13:
          errStr = "Reading card module disconnected (Reserved)";
          break;
        case 14:
          errStr = "Electricity Meter Disconnect Failure";
          break;
        case 15:
          errStr = "Communication Module Communication Timeout";
          break;
        case 16:
          errStr = "Local Server Disconnected ";
          break;
        case 17:
          errStr = "Insufficient Balance";
          break;
        case 18:
          errStr = "Disconnect from Central Server";
          break;
        case 19:
          errStr = "Illegal Card";
          break;
        case 20:
          errStr = "Invalid Card";
          break;
        case 21:
          errStr = "Communication Module Disconnected";
          break;
        case 22:
          errStr = "Writing Current Failed (Reserved)";
          break;
        case 23:
          errStr = "Overcurrent Protection";
          break;
        case 24:
          errStr = "VIN or Card Number Validation Failure (Reserved)";
          break;
        case 25:
          errStr = "Please Re-plug Charging Guns (Vehicle Not Responding)";
          break;
        case 26:
          errStr = "Contactor Back-checking Signal Failure";
          break;
        case 27:
          errStr = "Internal Temperature Sensor Disconnected";
          break;
        case 28:
          errStr = "Internal Temperature Sensor Shorted";
          break;
        case 29:
          errStr = "Gun 01 Temperature Sensor Disconnected";
          break;
        case 30:
          errStr = "Gun 01 Temperature Sensor Shorted";
          break;
        case 31:
          errStr = "Gun 02 Temperature Sensor Disconnected";
          break;
        default:
          errStr = "Unknown Error Code";
      }
      return errStr;
    },

    // second error code translation table for SA.
    secondErrorTable_SA(errorBit) {
      var errorString;
      switch (errorBit) {
        case 11:
          errorString = "Disconnect from Vehicle Communication";
          break;
        default:
          errorString = "Reserved";
      }
      return errorString;
    }
  },

  beforeDestroy() {
    clearInterval(this.dataPolling);
  },

  created() {
    this.onCompanyChange(this.displayCompanies[0]);
  }
};
</script>
